<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <el-form-item>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">添加
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="warning" icon="el-icon-refresh" size="small" @click="begin">刷新</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="name" label="名称" width="230" fixed>
                    <template slot-scope="scope">
                        <div v-html="scope.row.title"> </div>
                    </template> </el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column prop="count" label="菜单" width="160">
                    <template slot-scope="scope">
                        <el-switch active-value="0" inactive-value="1" v-model="scope.row.is_menu" active-text="开启"
                            inactive-text="关闭" @change="switchage(scope.row,'is_menu',scope.row.is_menu)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="置顶" width="160">
                    <template slot-scope="scope">
                        <el-switch active-value="0" inactive-value="1" v-model="scope.row.is_hot" active-text="开启"
                            inactive-text="关闭" @change="switchage(scope.row,'is_hot',scope.row.is_hot)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="状态" width="160">
                    <template slot-scope="scope">
                        <el-switch active-value="0" inactive-value="1" v-model="scope.row.status" active-text="开启"
                            inactive-text="关闭" @change="switchage(scope.row,'status',scope.row.status)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="180"> </el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="danger" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>


        <!-- 设置 -->
        <el-dialog title="分类设置" :visible.sync="dialoged" top="80px" width="60%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" :model="forms" label-width="120px" :rules="rules" class="forms-lines">
                    <el-form-item label="选择分类" prop="fl_value">
                        <el-select v-model="forms.fl_value" size="small" filterable placeholder="请选择">
                            <el-option v-for="item in  fl_options" :key="item.id" :label="item.title" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item label="上传封面">
                          <el-upload class="avatar-uploader" action="admin/ShopAttachments/image"  ref="upload"
                            :headers="{ token:$store.state.user.token }" :data="{ module:'goods' }"  :limit="1"
                            :file-list="fileList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                     </el-form-item>
                    <el-form-item  label="名称" prop="title">
                        <el-input size="small" v-model="forms.title" class="zwitdh"></el-input>
                    </el-form-item>
                     <el-form-item  label="排序">
                        <el-input size="small" v-model="forms.sort" class="zwitdh"></el-input>
                    </el-form-item>
                    <el-form-item  label="菜单" required>
                        <el-radio-group v-model="forms.is_menu">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                     <el-form-item  label="置顶" required>
                        <el-radio-group v-model="forms.is_hot">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                     <el-form-item  label="状态" required>
                        <el-radio-group v-model="forms.status">
                            <el-radio :label="0">开启</el-radio>
                            <el-radio :label="1">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submited('forms')" size="small">确 定</el-button>
                <el-button @click="dialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import { mapState } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,

                // 
                dialoged: false,
                fl_options:[],
                mapListed:[],
                fileList:[],
                forms: {
                    fl_value:0,
                    title:'',
                    sort:'50',
                    is_menu:1,
                    is_hot:1,
                    status:0,
                },
                rules: {
                    fl_value: [{
                        required: true,
                        message: '请选择分类',
                        trigger: 'blur'
                    }],
                    title: [{
                        required: true,
                        message: '请填写名称',
                        trigger: 'blur'
                    }],
                },
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 175 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 175 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
                that.getflxx()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios
                    .post("/admin/ShopCategory/index", {
                        page: that.currentPage,
                        page_count: that.pagesize
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false  
                        that.tableData = response.data.data.data
                        that.count = response.data.data.count
                        that.tableData.forEach(element => {
                            element.status = element.status.toString()
                            element.is_menu = element.is_menu.toString()
                            element.is_hot = element.is_hot.toString()
                        });
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            // 
            handleAdd() {
                let that = this
                that.dialoged = true
                this.forms.title=''
                 this.mapListed =[]
                 this.fileList=[]
                that.eid = '0'
            },
            submited(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var src =this.mapListed.map(item=>item.response.data.src)
                        axios
                            .post("/admin/ShopCategory/editor", {
                                id: this.eid,
                                pid: this.forms.fl_value,
                                file: '',
                                photo:src.toString(),
                                title:this.forms.title,
                                sort: this.forms.sort,
                                is_menu:  this.forms.is_menu,
                                is_hot:this.forms.is_hot,
                                status: this.forms.status,
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    this.search()
                                    this.dialoged = false
                                    this.$message('操作成功');
                                } else {
                                    this.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {})
                    } else {
                        return false;
                    }
                });
            },
            async handleEdit(row) {
                this.forms.title=''
                 this.mapListed =[]
                 this.fileList=[]
                this.dialoged = true
                this.eid = row.id
                await this.getinfo()
            },
            async getinfo() {
                await axios
                    .post("/admin/ShopCategory/read", {
                        id: this.eid,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data.data
                        this.forms.fl_value = data.pid
                        this.forms.title=data.title
                        this.forms.sort=data.sort
                        this.forms.is_menu=data.is_menu
                        this.forms.is_hot=data.is_hot
                        this.forms.status=data.status
                        this.mapListed =this.fileList=[{url:data.photo,response:{data:{src:data.photo}}}]
                    })
                    .catch(error => {})
            },
            getflxx(){
                    axios
                        .post("/admin/ShopCategory/read", {
                            id: this.eid,
                        }, {
                            token: true
                        })
                        .then(response => {
                            var arr=[{id:0,title:'顶级分类'}]
                            this.fl_options=arr.concat( response.data.data.cat)
                        })
                        .catch(error => {})
            },
            handleDelete(row) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/ShopCategory/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
             // 
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed=fileList
            },
            uploadRmove(file, fileList) {
                this.mapListed=fileList
            },
            switchage(row,item,val){
                axios
                    .post("/admin/ShopCategory/field", {
                        id: row.id,
                        name: item,
                        value:val

                    }, {
                        token: true
                    })
                    .then(response => {
                    })
                    .catch(error => {})
            },
        },

    };
</script>


<style scoped>
.zwitdh{
    width: 220px;
}
</style>